// utils/applyNormalDirectionFilter.js
import * as THREE from 'three'

export default function applyNormalDirectionFilter(material, dirObjectSpace, keep = 'out', eps = 0.02) {
  const dir = (dirObjectSpace || new THREE.Vector3(0, 0, 1)).clone().normalize()

  material.side = THREE.DoubleSide

  material.onBeforeCompile = (shader) => {
    shader.uniforms.uDirObj = { value: dir }
    shader.uniforms.uKeep = { value: keep === 'out' ? 1.0 : -1.0 }
    shader.uniforms.uEps = { value: eps }

    // VERTEX: uniform + varyingi
    shader.vertexShader = shader.vertexShader
      .replace(
        '#include <common>',
        `#include <common>
uniform vec3 uDirObj;
varying vec3 vWorldPos;
varying vec3 vDirWorld;`
      )
      .replace(
        '#include <project_vertex>',
        `vWorldPos = (modelMatrix * vec4(transformed, 1.0)).xyz;
vDirWorld = normalize((modelMatrix * vec4(uDirObj, 0.0)).xyz);
#include <project_vertex>`
      )

    // FRAGMENT: derivatywy + test dot()
    shader.fragmentShader = shader.fragmentShader
      .replace(
        '#include <common>',
        `#include <common>
varying vec3 vWorldPos;
varying vec3 vDirWorld;
uniform float uKeep;
uniform float uEps;
#ifdef GL_OES_standard_derivatives
#extension GL_OES_standard_derivatives : enable
#endif`
      )
      .replace(
        '#include <dithering_fragment>',
        `
vec3 faceN = normalize(cross(dFdx(vWorldPos), dFdy(vWorldPos)));
float d = dot(faceN, normalize(vDirWorld));

// keep out: d > eps
// keep in:  d < -eps
if (uKeep > 0.0) { if (d <= uEps) discard; }
else            { if (d >= -uEps) discard; }

#include <dithering_fragment>`
      )
  }

  material.customProgramCacheKey = () =>
    `ndir_fix_${keep}_${dir.x.toFixed(3)}_${dir.y.toFixed(3)}_${dir.z.toFixed(3)}_${eps}`

  material.needsUpdate = true
  return material
}
